import { render, staticRenderFns } from "./UnsupportedProvider.vue?vue&type=template&id=05a6b996&"
import script from "./UnsupportedProvider.vue?vue&type=script&lang=js&"
export * from "./UnsupportedProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports